export const TOGGLE_GOING_TO_CLOSE_PARKING = 'TOGGLE_GOING_TO_CLOSE_PARKING'

export function displayGoingToCloseParkingReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_GOING_TO_CLOSE_PARKING:
            return action.payload
        default: return state
    }
}